import { useCallback, useEffect, useRef } from 'react'
import Drawer from '../components/Drawer.fabric'
import Colors from '../components/Colors'

export const useTiles = ({
  ref,
  transform,
  groups,
  leaves,
  width,
  height,
  globalSearchSymbol,
  baseValue,
  entity,
}) => {
  const drawer = useRef(new Drawer())
  const colors = useRef(new Colors().createScale())

  useEffect(() => {
    window.requestAnimationFrame(() => {
      if (ref.current) {
        drawer.current.setProps({
          canvas: ref.current,
          colorScale: colors.current,
          width,
          height,
          globalSearchSymbol,
          baseValue,
          entity,
        })

        const context = ref.current.getContext('2d')

        if (context) {
          context.save()
          drawer.current.clear()
          context.translate(transform.x, transform.y)
          context.scale(transform.k, transform.k)
          drawer.current.draw(groups, 'groups')
          drawer.current.draw(leaves, 'leaves')
          context.restore()
        }
      }
    })
  }, [
    ref,
    transform,
    groups,
    leaves,
    width,
    height,
    globalSearchSymbol,
    baseValue,
    entity,
  ])

  const highlight = useCallback(
    group => {
      window.requestAnimationFrame(() => {
        if (ref.current) {
          const context = ref.current.getContext('2d')

          if (!context) {
            return
          }

          context.save()
          drawer.current.clear()

          context.translate(transform.x, transform.y)
          context.scale(transform.k, transform.k)

          drawer.current.setTarget(group || null)
          drawer.current.redrawWithOldData()

          context.restore()
        }
      })
    },
    [transform, ref]
  )

  return { drawer, colors, highlight }
}
